import { c as a } from "../../clsx-OuTLNxxd.js";
const n = {
  white: "#FDFDFF",
  glassColor: "color-mix(in oklab, #ffffff 30%, transparent)",
  accent: "#B3EAD5",
  mutedDark: "#1E2657"
}, c = (o) => ({
  ...o,
  borderRadius: 16,
  colors: {
    ...o.colors,
    primary: "dark",
    primary25: "accent"
  }
}), s = {
  container: () => "glass border border-transparent rounded-lg",
  control: () => "border border-transparent text-sm p-0.5 rounded-xl",
  input: () => "text-white dark:focus:border-transparent dark:focus:ring-0 ring-transparent ring-offset-0 focus:box-shadow-none shadow-none",
  valueContainer: () => "text-white",
  singleValue: () => "text-white",
  menu: () => "z-1000 glass rounded-xl shadow-lg",
  menuList: () => "z-1000 text-white hover:cursor-pointer",
  menuPortal: () => "z-999",
  option: ({ isFocused: o, isSelected: r }) => a({
    "z-1001 dark:bg-accent/30 cursor-pointer dark:cursor-pointer": r || o
  })
}, d = {
  container: (o, { isDisabled: r }) => ({
    ...o,
    opacity: r ? 0.5 : 1,
    cursor: r ? "not-allowed" : "default"
  }),
  placeholder: ({ ...o }) => ({ ...o, color: n.white }),
  control: ({ ...o }, { isDisabled: r }) => ({
    ...o,
    borderRadius: "8px",
    backgroundColor: n.glassColor,
    backdropFilter: "blur(15px)",
    border: "none",
    boxShadow: "none",
    cursor: r ? "not-allowed" : "default",
    pointerEvents: "auto",
    "&:hover": {
      border: "none"
    }
  }),
  input: ({ ...o }) => ({
    ...o,
    color: n.white
  }),
  menu: ({ backgroundColor: o, ...r }) => ({
    ...r,
    backgroundColor: n.glassColor,
    backdropFilter: "blur(20px)"
  }),
  menuPortal: ({ ...o }) => ({
    ...o,
    zIndex: 9999
  }),
  option: ({ backgroundColor: o, ...r }, { isSelected: t, isFocused: e }) => ({
    ...r,
    cursor: "pointer",
    backgroundColor: t || e ? n.accent : "",
    opacity: t || e ? 0.7 : 1,
    color: t || e ? n.mutedDark : n.white
  }),
  singleValue: ({ ...o }) => ({
    ...o,
    color: n.white
  }),
  clearIndicator: (o) => ({ ...o }),
  dropdownIndicator: (o, { isDisabled: r }) => ({
    ...o,
    opacity: r ? 0.4 : 1
  }),
  group: (o) => ({ ...o })
};
export {
  s as classNames,
  d as styles,
  c as theme
};
